import React from 'react'
import { withRouter } from 'react-router'
import SearchUI from '../../widgets/input/SearchUI'
import AvatarUI from '../../widgets/output/AvatarUI'
import LRTableBodyUI from '../../widgets/layout/LRTableBodyUI'
import LRTableActionsUI from '../../widgets/layout/LRTableActionsUI'
import LRTableRowLinkUI from '../../widgets/layout/LRTableRowLinkUI'
import SelectSingleSF from '../../widgets/input/SelectSingleSF'
import IconButtonUI from '../../widgets/action/IconButtonUI'
import IconButtonLinkUI from '../../widgets/action/IconButtonLinkUI'
import './AccountUserList.css'

const AccountUserListUI = ({context, messageList, accountUserList,
    // filters
    searchFilter, onSearchFilterChange, allRoleList, onRoleFilterChange, roleFilter,
    // modes
    selectedCount,
    // event handlers
    onRefreshClick, onUpdateClick, onDeleteClick, onRowClick}) =>
  <div className='c_acc_users'>
    <LRTableActionsUI location='top'
      left={
        <ActionLeftUI
          context={context}
          messageList={messageList}
          selectedCount={selectedCount}
          onRefreshClick={onRefreshClick}
          onUpdateClick={onUpdateClick}
          onDeleteClick={onDeleteClick }
        />
      }
      right={
        <ActionTopRightUI
          context={context}
          messageList={messageList}
          searchFilter={searchFilter}
          onSearchFilterChange={onSearchFilterChange}
          onRoleFilterChange={onRoleFilterChange}
          allRoleList={allRoleList}
          roleFilter={roleFilter}
        />
      }
    />

    <LRTableBodyUI>
      {
        accountUserList.map((accountUser, i) =>
          <AccountUserRowUI key={i} context={context} accountUser={accountUser}
            messageList={messageList} onRowClick={onRowClick}
          />
        )
      }
    </LRTableBodyUI>
  </div>

const ActionLeftUI = ({context, messageList, selectedCount, onRefreshClick, onUpdateClick, onDeleteClick}) =>
  <React.Fragment>
    {
      selectedCount === 0 &&
      <div className='g_flex_h'>
        <IconButtonUI messageList={messageList} icon='icon-refresh' onClick={onRefreshClick} labelKey='c_refresh' />
        {
          context.permissions.includes('acc_manage') &&
          <IconButtonLinkUI messageList={messageList} icon='icon-user-plus' to='/settings/members/invite' labelKey='c_invite_user' />
        }
      </div>
    }
    {
      selectedCount > 0 &&
      <div className='action g_flex_h'>
        <IconButtonUI messageList={messageList} icon='icon-pencil' onClick={onUpdateClick} labelKey='c_update_users' />
        <IconButtonUI messageList={messageList} icon='icon-trash-o' onClick={onDeleteClick} labelKey='c_remove_users' />
      </div>
    }
  </React.Fragment>

const ActionTopRightUI = ({context, messageList, searchFilter, onSearchFilterChange, allRoleList, onRoleFilterChange, roleFilter}) =>
  <div className='g_flex_h'>
    <div style={{width: 100}}>
      <SelectSingleSF
        messageList={messageList}
        optionList={allRoleList.map(role => ({value: role.key, label: role.value}))}
        onChange={onRoleFilterChange}
        selectedKey={roleFilter}
        removeKey='c_all'
      />
    </div>
    <SearchUI value={searchFilter} onChange={onSearchFilterChange} />
  </div>

const AccountUserRowUI = ({context, accountUser, messageList, onRowClick}) =>
  <LRTableRowLinkUI
    context={context}
    left={<RowLeftUI context={context} accountUser={accountUser} onRowClick={onRowClick} />}
    right={<RowRightUI accountUser={accountUser} messageList={messageList} />}
    to={`/settings/members/${accountUser.userId}`}
  />

const RowLeftUI = ({context, accountUser, onRowClick}) =>
  <div>
    <div className='g_flex_h name_div'>
    {
      context.permissions.includes('acc_manage') &&
      <input type="checkbox" className={`checkbox ${accountUser.accountOwner ? 'owner' : ''}`}
        checked={accountUser.selected} onChange={() => {}}
        onClick={context.permissions.includes('acc_manage') ? onRowClick : null}
        data-row-id={accountUser.userId}
      />
    }
    <AvatarUI avatarUrl={accountUser.avatarUrl} />
    <label className='name g_m_left_50'>
      {accountUser.name}
    </label>
    {
      accountUser.status === 'invited' &&
      <div className='icon icon-envelope tag'></div>
    }
    {
      accountUser.userId === context.session.userId &&
      <div className='self'></div>
    }
    </div>

    <div className='id_div'>
    {accountUser.email}
    </div>

    {
      accountUser.dinNumber &&
      <div className='g_muted id_div'>
        <span>DIN: {accountUser.dinNumber}</span>
        <span className='g_m_left_50'>{accountUser.dinStatus}</span>
        <span className='g_m_left_50'>{accountUser.dinFullName}</span><br/>
        <span>{accountUser.dinEmail}</span>
        <span className='g_m_left_50'>{accountUser.dinLastUpdated}</span><br/>
        <span>{accountUser.dinAddress}</span>
      </div>
    }
    {
      accountUser.panNumber &&
      <div className='g_muted id_div'>
        <span>PAN: {accountUser.panNumber}</span>
        <span className='g_m_left_50'>{accountUser.panFullName}</span>
      </div>
    }
    {
      accountUser.aadhaarNumber &&
      <div className='g_muted id_div'>
        <span>Aadhaar: {accountUser.aadhaarNumber}</span>
        <span className='g_m_left_50'>{accountUser.aadhaarFullName}</span>
      </div>
    }
  </div>

const RowRightUI = ({accountUser, messageList}) =>
  <div className='g_flex_h'>
    <span className='g_muted'>
      {accountUser.roleName}
    </span>
  </div>

export default withRouter(AccountUserListUI)
